import rootRoute from './root';

export const route = rootRoute;

export default route;
